import React, { useState, useEffect } from "react";
import _ from "lodash";
import usePrevious from "@common/hooks/usePrevious";
import { MapForCatalog } from "@kursk/components/ui/MapForCatalog/MapForCatalog";
import { FILTERS_BY_ENTITY_TYPE, IFilters } from "@common/redux/slices/entities.slice";
import { fetchPointsPlaces } from "@kursk/utils/fetchPins";

interface IPlacesMapProps {
  filters: IFilters;
}

export function PlacesMap({ filters }: IPlacesMapProps) {
  const [items, setItems] = useState([]);
  const prevFilters = usePrevious(filters);

  const getLoadOptions = () => {
    const filtersFields = _.without(FILTERS_BY_ENTITY_TYPE.places, 'priceSource');
    const options = {
      ..._(filters).pick(filtersFields).omitBy((value) => _.isNil(value) || _.isNaN(value) || value === 0).value(),
    }
    if (options.minPrice) options.minPrice = options.minPrice * 100;
    if (options.maxPrice) options.maxPrice = options.maxPrice * 100;

    return options;
  };

  const loadMapPoints = async() => {
    const params = getLoadOptions();
    const response = await fetchPointsPlaces({ ...params, type: 'place' });
    if (response) {
      setItems(response.map((item) => ({ ...item, type: 'places' })))
    }
  };

  useEffect(() => {
    if (prevFilters && !_.isEqual(prevFilters, filters)) {
      loadMapPoints();
    }
  }, [filters]);

  useEffect(() => {
    loadMapPoints();
  }, []);

  return (
    <MapForCatalog items={items} entityType="places" />
  );
}
